import './FilterOptionItemAmount.scss';

import type { ReactNodeRenderer } from '@components/CustomizableNode';
import CustomizableNode from '@components/CustomizableNode';
import { createClsNameMap, mapModifiers } from '@utils';
import type { PropsWithChildren } from 'react';

export const clsNameMap = createClsNameMap({
  modifiers: ['selected'],
})('filter-option-item-amount');

export type FilterOptionItemAmountProps = PropsWithChildren<{
  isSelected: boolean;
  label?: string;
  onRender?: ReactNodeRenderer;
}>;

const FilterOptionItemAmount = ({
  children,
  isSelected,
  label = `Number of products: ${children}`,
  onRender,
}: FilterOptionItemAmountProps) => {
  return (
    <span aria-label={label} className={mapModifiers(clsNameMap, { selected: isSelected })}>
      <CustomizableNode renderer={onRender}>{children}</CustomizableNode>
    </span>
  );
};

export default FilterOptionItemAmount;
